import styled from "styled-components";

export const Container = styled.div`
  max-width: 1128px;
  width: 80%;
  margin: 0 auto;

  h3 {
    font-size: 2rem;
    font-weight: bold;
  }

  img {
    max-width: 100%;
    object-fit: contain;
  }

  p,
  a {
    font-size: 1.8rem;
  }

  @media (min-width: 800px) {
    p,
    a {
      font-size: 2rem;
    }
    h3 {
      font-size: 2.2rem;
      font-weight: bold;
    }
  }
`;

export const Title = styled.h2`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 2.7rem;

  @media (max-width: 800px) {
    font-size: 1.7rem;
  }
`;
